(() => {
    window.addEventListener("DOMContentLoaded", () => {
        if (!document.querySelector('.personcarousel')) {
            return
        }

        document.querySelectorAll('.personcarousel__image').forEach((currentItem) => {
            currentItem.addEventListener('click', () => {
                let targetItem = currentItem.closest('.personcarousel__item')
                let activeItem = document.querySelector('.personcarousel__item--active')
                let targetParent = targetItem.parentNode;
                let sibling = targetItem.nextSibling === activeItem ? targetItem : targetItem.nextSibling;

                activeItem.classList.remove('personcarousel__item--active')
                targetItem.classList.add('personcarousel__item--active')

                activeItem.parentNode.insertBefore(targetItem, activeItem);
                targetParent.insertBefore(activeItem, sibling);
            })
        })
    })
}) ()